import { NgModule } from '@angular/core';
import { MapsetS100m01Component } from './mapset-s100m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [MapsetS100m01Component]
})

export class MapsetModule { }

